import { useEffect } from 'react';

const MagentoDownload = () => {
    useEffect(() => {
        // Redirect to actual static file URL
        window.location.href = '/plugins/plugin/magento2.zip';
    }, []);
    return <>
    </>;
};

export default MagentoDownload;
